module.exports = __webpack_public_path__ + "static/img/title-de.f8e2ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/title/title-de.png
// module id = p+iO
// module chunks = 1